module.exports = __webpack_public_path__ + "static/WEDDING E&M-53-faafe4f72de2461c1c8ef6b1be523083.jpg";